module.exports = __webpack_public_path__ + "img/24x7handsnl.37b4bd02.png";